// these should match EnumWhereOperator.java
export const EQ = 'EQ'; //=
export const NOT = 'NOT';
export const CONTAINS = 'CONTAINS';
export const NOT_CONTAINS = 'NOT_CONTAINS';
export const LT = 'LT'; // <
export const LTE = 'LTE'; // <=
export const GT = 'GT'; // >
export const GTE = 'GTE'; // <=
export const BEFORE = 'BEFORE';
export const AFTER = 'AFTER';
export const LESS_THAN = 'LESS_THAN'; // for relative time (e.g. less than 3 weeks ago)
export const MORE_THAN = 'MORE_THAN'; // for relative time (e.g. more than 1 month from now)
export const ONE_OF = 'ONE_OF';
export const NOT_ONE_OF = 'NOT_ONE_OF';

export type Operator =
  | typeof EQ
  | typeof NOT
  | typeof CONTAINS
  | typeof NOT_CONTAINS
  | typeof LT
  | typeof LTE
  | typeof GT
  | typeof GTE
  | typeof BEFORE
  | typeof AFTER
  | typeof LESS_THAN
  | typeof MORE_THAN
  | typeof ONE_OF
  | typeof NOT_ONE_OF;

export function getOperatorSymbol(operator: Operator) {
  switch (operator) {
    case EQ:
      return '=';
    case NOT:
      return 'not';
    case CONTAINS:
      return 'contains';
    case NOT_CONTAINS:
      return 'not contains';
    case BEFORE:
      return 'is before';
    case AFTER:
      return 'is after';
    case LESS_THAN:
      return 'less than';
    case MORE_THAN:
      return 'more than';
    case LT:
      return '<';
    case GT:
      return '>';
    case LTE:
      return '<=';
    case GTE:
      return '>=';
    case ONE_OF:
      return 'is one of';
    case NOT_ONE_OF:
      return 'is not one of';
    default:
      return operator;
  }
}
